export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2 }).format(
    Number(n || 0)
  );

export const num = (n, d = 0) =>
  new Intl.NumberFormat("en-GB", { minimumFractionDigits: d, maximumFractionDigits: d }).format(Number(n || 0));

// UK date DD/MM/YYYY from ISO (YYYY-MM-DD or full ISO)
export const ukDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const ukDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const VARIANCE = {
  within_target: { label: "Within Target", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", icon: "CheckCircle2" },
  above_target: { label: "Above Target", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", icon: "AlertTriangle" },
  requires_review: { label: "Requires Review", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30", icon: "AlertCircle" },
};
